// Configuration loaded from window.AWS_CONFIG (set by /config.js)
export function getConfig() {
  const config = window.AWS_CONFIG || {};

  return {
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId || 'NOT_CONFIGURED',
        userPoolClientId: config.clientId || 'NOT_CONFIGURED',
        region: config.region || 'us-east-1'
      }
    },
    API: {
      REST: {
        chatApi: {
          endpoint: config.apiUrl || 'NOT_CONFIGURED',
          region: config.region || 'us-east-1'
        }
      }
    }
  };
}
